'use strict';exports.__esModule = true;exports.verifyCode = exports.sendPhoneNumber = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}var

promise = _reduxLoop.Effects.promise;

var sendPhoneNumber = (0, _reduxAct.createAction)('/SEND_PHONE_NUMBER_FOR_VERIFICATION');
var sendPhoneNumberSuccess = (0, _reduxAct.createAction)('/SEND_PHONE_NUMBER_FOR_VERIFICATION_SUCCESS');
var sendPhoneNumberFail = (0, _reduxAct.createAction)('/SEND_PHONE_NUMBER_FOR_VERIFICATION_FAIL');
var verifyCode = (0, _reduxAct.createAction)('/VERIFY_CODE');
var verifyCodeSuccess = (0, _reduxAct.createAction)('/VERIFY_CODE_SUCCESS');
var verifyCodeFail = (0, _reduxAct.createAction)('/VERIFY_CODE_FAIL');

var initialState = {
  sendingPhoneNumber: false,
  sendingVerificationCode: false,
  phoneNumberSent: false,
  verificationCodeSent: false,
  codeIsValid: false,
  codeError: null,
  phoneError: null };


var phoneVerificationRequest = function phoneVerificationRequest(_ref) {var accessToken = _ref.accessToken,verificationData = _objectWithoutProperties(_ref, ['accessToken']);return (
    _axios2.default.post('/users/phone/send_verification', verificationData, { headers: { access_token: accessToken } }).
    then(sendPhoneNumberSuccess, sendPhoneNumberFail));};

var verifyCodeRequest = function verifyCodeRequest(_ref2) {var accessToken = _ref2.accessToken,code = _ref2.code;return (
    _axios2.default.post('/users/phone/check_verification', { code: code }, { headers: { access_token: accessToken } }).
    then(verifyCodeSuccess, verifyCodeFail));};

var phoneVerificationHandler = function phoneVerificationHandler(state, data) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    sendingPhoneNumber: true,
    phoneNumberSent: false,
    phoneError: null }),
  promise(phoneVerificationRequest, data));};

var verifyCodeHandler = function verifyCodeHandler(state, verificationCode) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    sendingVerificationCode: true,
    verificationCodeSent: false,
    codeIsValid: false,
    codeError: null }),
  promise(verifyCodeRequest, verificationCode));};

var sendPhoneNumberSuccessHandler = function sendPhoneNumberSuccessHandler(state, action) {return Object.assign({},
  state, {
    data: action,
    sendingPhoneNumber: false,
    phoneNumberSent: true,
    verificationCodeSent: false });};


var sendPhoneNumberFailHandler = function sendPhoneNumberFailHandler(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while sending phone number');

  return Object.assign({},
  state, {
    sendingPhoneNumber: false,
    phoneError: error });

};

var verifyCodeSuccessHandler = function verifyCodeSuccessHandler(state, action) {return Object.assign({},
  state, {
    sendingVerificationCode: false,
    verificationCodeSent: true,
    codeIsValid: true,
    data: action });};


var verifyCodeFailHandler = function verifyCodeFailHandler(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while verifying phone code');

  return Object.assign({},
  state, {
    sendingVerificationCode: false,
    verificationCodeSent: false,
    codeIsValid: false,
    codeError: error });

};

var phoneSmsVerification = (0, _reduxAct.createReducer)(function (on) {
  on(sendPhoneNumber, phoneVerificationHandler);
  on(sendPhoneNumberSuccess, sendPhoneNumberSuccessHandler);
  on(sendPhoneNumberFail, sendPhoneNumberFailHandler);

  on(verifyCode, verifyCodeHandler);
  on(verifyCodeSuccess, verifyCodeSuccessHandler);
  on(verifyCodeFail, verifyCodeFailHandler);
}, initialState);exports.


sendPhoneNumber = sendPhoneNumber;exports.
verifyCode = verifyCode;exports.default =


phoneSmsVerification;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/phoneSmsVerification.js
// module id = 1290
// module chunks = 0